export interface ApiResponse<T> {
  success: boolean;
  data?: T;
  error?: ApiError;
}

export interface ApiError {
  code: string;
  message: string;
  details?: Record<string, unknown>;
}

export interface PaginatedResponse<T> {
  items: T[];
  total: number;
  page: number;
  pageSize: number;
  hasMore: boolean;
}

export interface ListParams {
  page?: number;
  pageSize?: number;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
}

export type ApiEndpoint =
  | 'auth/github'
  | 'auth/github/callback'
  | 'auth/me'
  | 'sessions'
  | 'projects'
  | 'devices';

export const API_ENDPOINTS = {
  AUTH_GITHUB: '/api/auth/github',
  AUTH_GITHUB_CALLBACK: '/api/auth/github/callback',
  AUTH_ME: '/api/auth/me',
  SESSIONS: '/api/sessions',
  PROJECTS: '/api/projects',
  DEVICES: '/api/devices',
} as const;
